import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const EmailSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      height="33"
      viewBox="0 0 33 33"
      width="33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        clip-rule="evenodd"
        d="m16.5 17 8-6h-16zm0 1.77778-8-5.77778v8h16v-8z"
        fill={color}
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default EmailSvg
